import React from "react";

const TempleGridContinueSubscription = () => {
  return (
    <div>
      if no subscription .... direct to here
      <div>
        background
        <div></div>
      </div>
    </div>
  );
};

export default TempleGridContinueSubscription;
